import {
  ofertaLimitesDeTarjetas,
  nombreTarjetaDebito,
  paquetesBeneficios
} from "@/config/constants/paquetesBeneficios.js";

describe("ofertaLimitesDeTarjetas", () => {
  it("debe retornar el texto correcto para una sola tarjeta", () => {
    const tarjetas = [{ tipoTarjeta: "CI", limite: "200" }];
    expect(ofertaLimitesDeTarjetas(tarjetas)).toEqual(
      "Con un límite de compra de $<span data-obfuscate>200</span>"
    );
  });

  it("debe retornar el texto correcto cuando es mas de una tarjeta", () => {
    const tarjetas = [
      { tipoTarjeta: "CI", limite: "200" },
      { tipoTarjeta: "12", limite: "190" }
    ];
    expect(ofertaLimitesDeTarjetas(tarjetas)).toEqual(
      "- Tarjeta de crédito Visa Internacional con un límite de compra de $<span data-obfuscate>200<br></span>- Tarjeta de crédito Mastercard Internacional con un límite de compra de $<span data-obfuscate>190</span>"
    );
  });
});

describe("nombreTarjetaDebito", () => {
  it("debe retornar el nombre para paquete libreton premium", () => {
    expect(nombreTarjetaDebito("08")).toEqual("Tarjeta Visa Débito Premium");
  });

  it("debe retornar el nombre por defecto", () => {
    expect(nombreTarjetaDebito("tarjeta")).toEqual("Tarjeta Visa Débito");
  });

  it("debe retornar el nombre para paquete libreton premium world", () => {
    expect(nombreTarjetaDebito("04")).toEqual(
      "Tarjeta Visa Débito Premium World"
    );
  });
});

describe("paquetesBeneficios", () => {
  it("debe retornar los beneficios para el paquete libreton black", () => {
    const paquetes = {
      tipoPaquete: "04",
      tarjetas: [
        { tipoTarjeta: "SS", limite: "2000000" },
        { tipoTarjeta: "12", limite: "1900000" }
      ],
      cajasDeAhorro: []
    };
    expect(paquetesBeneficios(paquetes)).not.toBeNull();
  });

  it("debe retornar los beneficios para el paquete libreton platinum", () => {
    const paquetes = {
      tipoPaquete: "08",
      tarjetas: [
        { tipoTarjeta: "LL", limite: "2000000" },
        { tipoTarjeta: "12", limite: "1900000" }
      ],
      cajasDeAhorro: []
    };
    expect(paquetesBeneficios(paquetes)).not.toBeNull();
  });

  it("debe retornar los beneficios para el paquete libreton full", () => {
    const paquetes = {
      tipoPaquete: "07",
      tarjetas: [
        { tipoTarjeta: "PP", limite: "2000000" },
        { tipoTarjeta: "12", limite: "1900000" }
      ],
      cajasDeAhorro: []
    };
    expect(paquetesBeneficios(paquetes)).not.toBeNull();
  });
  it("debe retornar los beneficios para el paquete libreton gold", () => {
    const paquetes = {
      tipoPaquete: "01",
      tarjetas: [
        { tipoTarjeta: "PP", limite: "2000000" },
        { tipoTarjeta: "12", limite: "1900000" }
      ],
      cajasDeAhorro: []
    };
    expect(paquetesBeneficios(paquetes)).not.toBeNull();
  });
  it("debe retornar los beneficios para el paquete libreton express", () => {
    const paquetes = {
      tipoPaquete: "09",
      tarjetas: [
        { tipoTarjeta: "CI", limite: "2000000" },
        { tipoTarjeta: "12", limite: "1900000" }
      ],
      cajasDeAhorro: []
    };
    expect(paquetesBeneficios(paquetes)).not.toBeNull();
  });
  it("debe retornar los beneficios para el paquete tarjeta suelta", () => {
    const paquetes = {
      tipoPaquete: "00",
      tarjetas: [
        { tipoTarjeta: "CI", limite: "2000000" },
        { tipoTarjeta: "12", limite: "1900000" }
      ],
      cajasDeAhorro: []
    };
    expect(paquetesBeneficios(paquetes)).not.toBeNull();
  });
});
